<template>
  <MissingPasswordSignInOptions
    :confirm-one-time-code-route="{ name: AppRouteNames.ONE_TIME_CODE_SIGN_IN, query: { email } }"
    :reset-link-sent-route="{ name: AppRouteNames.RESET_PASSWORD, query: { email, sent: 'true' } }"
    :for-role="UserRole.INVESTOR"
    :email="email"
  >
    <InvestorGoogleSignInButton :flow="'sign-in'" />
  </MissingPasswordSignInOptions>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';

import { MissingPasswordSignInOptions } from '@tallo/auth';
import { AppRouteNames } from '@tallo/investor/navigation';
import { UserRole } from '@tallo/user';

import InvestorGoogleSignInButton from './investor-google-sign-in-button.vue';

const route = useRoute();
const email = route.query.email as string;
</script>

<style lang="scss" scoped></style>
